import {BaseComponent, UseCallback} from "react-vextensions";
import {Button, Column, Div, Row, Text} from "react-vcomponents";
import {ES, HSLA, Link, Observer, PageContainer, RunInAction} from "web-vcore";
import {GetMaps} from "../../Server/DB/maps.js";
import {liveSkin} from "../../Utils/Styles/StyleManager.js";
import {E, VURL} from "js-vextensions";
import {store} from "../../Store/index.js";
import {GetUser, MeID} from "../../Server/DB/users.js";
import {DMap} from "../../Server/DB/maps/@Map.js";
import {ScrollView} from "react-vscrollview";
import {CanGetBasicPermissions} from "../../Server/DB/users/$user.js";
import {ShowSignInPopup} from "../@Shared/NavBar/UserPanel.js";
import {ShowAddMapDialog} from "./MapDetailsUI.js";
import {MapUIWrapper} from "./MapUIWrapper.js";
import React from "react";
import {observer_mgl} from "mobx-graphlink";

export const columnWidths = [0.8, 0.2];

export const MapsUI = observer_mgl(()=>{
	const selectedMapID = store.main.maps.selectedMapID;
	if (selectedMapID) {
		return (
			<PageContainer preset="full" style={{margin: 0}}>
				<MapUIWrapper mapID={selectedMapID}/>
			</PageContainer>
		);
	}

	return (
		<PageContainer style={{margin: "20px auto 20px auto", padding: 0, background: null as any}}>
			<MapListUI/>
		</PageContainer>
	);
});

export const MapListUI = observer_mgl(()=>{
	const maps = GetMaps();

	return (
		<Column className="clickThrough" style={E(
			{background: liveSkin.HeaderColor().css(), borderRadius: "10px 10px 0 0"},
		)}>
			<Row mt={10} p="0 10px">
				<Text>Maps</Text>
				<Button text="Add map" ml="auto"
					enabled={CanGetBasicPermissions(MeID())}
					onClick={()=>{
						if (MeID() == null) return void ShowSignInPopup();
						ShowAddMapDialog();
					}}/>
			</Row>
			<ScrollView style={ES({flex: 1})} contentStyle={ES({
				flex: 1, background: liveSkin.BasePanelBackgroundColor().alpha(1).css(), borderRadius: "0 0 10px 10px",
			})}>
				{maps.length == 0 && <div style={{textAlign: "center", fontSize: 18}}>No results.</div>}
				{maps.map((map, index)=><MapEntryUI key={index} index={index} last={index == maps.length - 1} map={map}/>)}
			</ScrollView>
		</Column>
	);
});

export const MapEntryUI = observer_mgl((props: {index: number, last: boolean, map: DMap})=>{
	const {index, last, map} = props;
	const creator = map && GetUser(map.creator);
	let mapNameToDisplay = map.name;

	const toURL = new VURL(undefined, ["maps", `${map.id}`]);
	const gadTextColor = HSLA(222, .33, .25, 1);
	return (
		<Column p="7px 10px" style={E(
			{background: index % 2 == 0 ? liveSkin.ListEntryBackgroundColor_Light().css() : liveSkin.ListEntryBackgroundColor_Dark().css()},
			last && {borderRadius: "0 0 10px 10px"},
		)}>
			<Row>
				<Div style={{position: "relative", flex: columnWidths[0]}}>
					<Link text={mapNameToDisplay} to={toURL.toString({domain: false})} style={E({fontSize: 17})} onClick={e=>{
						e.preventDefault();
						RunInAction("MapEntryUI.onClick", ()=>{
							store.main.page = "maps";
							store.main.maps.selectedMapID = map.id;
						});
					}}/>
				</Div>
				<span style={{flex: columnWidths[1]}}>{creator ? creator.displayName : "..."}</span>
			</Row>
		</Column>
	);
});